import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { PatientLayoutComponent } from './patient-layout/patient-layout.component';
import { LoginGuard } from '../auth/loginGuard';
import { PatientFavoritesComponent } from './patient-favorites/patient-favorites.component';
import { PatientAppointmentsComponent } from './patient-appointments/patient-appointments.component';
import { PatientFindCareComponent } from './patient-find-care/patient-find-care.component';
import { FindCareComponent } from '../shared/components/find-care/find-care.component';
import { FindCareTeamComponent } from '../shared/components/find-care/find-care-team/find-care-team.component';
import { PatientSettingsComponent } from './patient-settings/patient-settings.component';
import { PatientSubscriptionsComponent } from './patient-subscriptions/patient-subscriptions.component';
import { PatientCheckoutComponent } from './patient-checkout/patient-checkout.component';
import { PatientChoosePlanComponent } from './patient-choose-plan/patient-choose-plan.component';
import { PatientPlanDetailsComponent } from './patient-plan-details/patient-plan-details.component';
import { PatientTeldacplanComponent } from './patient-teldacplan/patient-teldacplan.component';
import { PatientTeldacFaqplanComponent } from './patient-teldac-faqplan/patient-teldac-faqplan.component';
import { PatientHealthadvocatePlanComponent } from './patient-healthadvocate-plan/patient-healthadvocate-plan.component';
import { PatientNbfitnessPlanComponent } from './patient-nbfitness-plan/patient-nbfitness-plan.component';
import { PatientNbrxPlanComponent } from './patient-nbrx-plan/patient-nbrx-plan.component';
import { PatientManifestrxPlanComponent } from './patient-manifestrx-plan/patient-manifestrx-plan.component';
import { PatientLifelockessentialPlanComponent } from './patient-lifelockessential-plan/patient-lifelockessential-plan.component';
import { PatientLabtestingPlanComponent } from './patient-labtesting-plan/patient-labtesting-plan.component';
import { PatientNbdealsPlanComponent } from './patient-nbdeals-plan/patient-nbdeals-plan.component';
import { PatientNbtravelPlanComponent } from './patient-nbtravel-plan/patient-nbtravel-plan.component';
import { PatientSponsoredPlanComponent } from './patient-sponsored-plan/patient-sponsored-plan.component';
import { PatientPetrxPlanComponent } from './patient-petrx-plan/patient-petrx-plan.component';
import { PatientPrivacyPolicyComponent } from './patient-privacy-policy/patient-privacy-policy.component';
import { PatientPaymentMethodComponent } from './patient-payment-method/patient-payment-method.component';
import { PatientActivePlanComponent } from './patient-active-plan/patient-active-plan.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: "/home",
    pathMatch: "full"
  },
  {
    path: 'patient',
    component: PatientLayoutComponent,
    children: [
      { path: '', loadChildren: '../patient/patient-profile/patient-profile.module#PatientProfileModule' },
      // {
      //   path: '',
      //   loadChildren: '../market-place/market-place.module#MarketPlaceModule'
      // },
      {
        path: 'profile',
        loadChildren: '../patient/patient-profile/patient-profile.module#PatientProfileModule'
      },
      {
        path: 'findcare',
        component: FindCareComponent,
        canActivate: [LoginGuard],
      },
      {
        path: 'findcare/:categoryId',
        component: FindCareComponent,
        canActivate: [LoginGuard],
      },
      {
        path: 'team/findcare',
        component: FindCareTeamComponent,
        canActivate: [LoginGuard],
      },
      {
        path: 'health',
        loadChildren: '../patient/patient-health/patient-health.module#PatientHealthModule'
      },
      // {
      //   path: 'subscriptions',
      //   component: PatientSubscriptionsComponent
      // },
      {
        path: 'marketplace',
        loadChildren: '../market-place/market-place.module#MarketPlaceModule'
      },
      {
        path: 'favorites',
        component: PatientFavoritesComponent
      },
      {
        path: 'appointments',
        component: PatientAppointmentsComponent
      },
      {
        path: "physician/profile",
        loadChildren:
          "../physician/profile/physician/physician-profile.module#PhysicianProfileModule",
        canActivate: [LoginGuard],
      },
      {
        path: 'patientsettings',
        component: PatientSettingsComponent,
        canActivate: [LoginGuard],
      },
      {
        path: 'patientPlanDetails',
        component: PatientPlanDetailsComponent,
        canActivate: [LoginGuard],
      },
      {
        path: 'setupCheckout/:id',
        component: PatientCheckoutComponent,
        canActivate: [LoginGuard],
      },
      {
        path: 'teladoc',
        component: PatientTeldacplanComponent,
        canActivate: [LoginGuard],
      },
      {
        path: 'teladocMentalHealth',
        component: PatientTeldacFaqplanComponent,
        canActivate: [LoginGuard],
      },
      {
        path: 'healthAdvocate',
        component: PatientHealthadvocatePlanComponent,
        canActivate: [LoginGuard],
      },
      {
        path: 'nbFitness',
        component: PatientNbfitnessPlanComponent,
        canActivate: [LoginGuard],
      },
      {
        path: 'nbRx',
        component: PatientNbrxPlanComponent, 
        canActivate: [LoginGuard],
      },
      {
        path: 'manifestRx',
        component: PatientManifestrxPlanComponent,
        canActivate: [LoginGuard],
      },
      {
        path: 'lifelockEssential',
        component: PatientLifelockessentialPlanComponent,
        canActivate: [LoginGuard],
      },
      {
        path: 'labTesting',
        component: PatientLabtestingPlanComponent,
        canActivate: [LoginGuard],
      },
      {
        path: 'nbDeals',
        component: PatientNbdealsPlanComponent,
        canActivate: [LoginGuard],
      },
      {
        path: 'nbTravel',
        component: PatientNbtravelPlanComponent,
        canActivate: [LoginGuard],
      },
      {
        path: 'petTelehealth',
        component: PatientSponsoredPlanComponent,
        canActivate: [LoginGuard],
      },
      {
        path: 'nbPetRx',
        component: PatientPetrxPlanComponent,
        canActivate: [LoginGuard],
      },
      {
        path: 'privacyPolicy',
        component: PatientPrivacyPolicyComponent,
        canActivate: [LoginGuard],
      },
      {
        path: 'payment-method',
        component: PatientPaymentMethodComponent,
        canActivate: [LoginGuard],
      },
      {
        path: 'subscription',
        component: PatientChoosePlanComponent,
        canActivate: [LoginGuard],
      },
      {
        path: 'mysubscription',
        component: PatientActivePlanComponent,
        canActivate: [LoginGuard],
      },
    ]
  }];

@NgModule({
  imports: [ReactiveFormsModule, RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PatientRoutingModule { }
